import UNIQUE_SESSION_ID from './getSessionId';

export default UNIQUE_SESSION_ID;
